<template>
  <el-container  style="display:block;">

		<el-row class="lel" style="box-shadow: 0px 3px 9px rgba(213, 218, 222);text-align: center;height: 120px;">
			<el-col :span="3" style="margin-top: 40px;text-align: right;margin-left: 30%;">
				<div class="block">

				<el-date-picker
				      v-model="value2"
				      align="right"
				      type="date"
				      placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
				      :picker-options="pickerOptions">
				</el-date-picker>
			  </div>
			</el-col>
      <el-col :span="3"  style="margin-left: 30px;margin-top: 40px;text-align: left;"><el-input v-model="phone" placeholder="用户ID\设备ID"></el-input></el-col>
			<el-col :span="1"  style="margin-top: 40px;" class="t-searched" @click.native="search()">筛选</el-col>

		</el-row>
    <el-row class="lel" style="background-color:#f0f4f7;margin-top: 5px;">
      <el-col :span="5" style="margin-left: 6%;margin-top: 100px;">
        <el-row class="user_n" style="height: 200px;width: 100%;background-color: #fff;">
          <el-col :span="6" style="margin-left: 9%;margin-top: 50px;">
            <img v-if="user['header']" :src="user['header']" style="height: 115px;width: 115px;border-radius:58px;" />
            <img v-else src="../../assets/image/user.png" />
          </el-col>
          <el-col :span="12" style="margin-left: 9%;margin-top: 50px;">
            <h3 style="margin-top: 25px;">Hi兔</h3>
            <div style="margin-top: 20px;">账户:{{user.phone}}</div>
          </el-col>
        </el-row>
        <el-row style="height: 600px;width: 100%;background-color: #fff;padding-top: 20px;">
          <el-row>
            <el-col :span="3" style="margin-left: 35px;">
              <div style="width: 3px;height:20px;background-color:#0000FE;"></div>
            </el-col>
            <el-col :span="12">
              我的位置
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px;" v-for="(items,indexs) in address" :key="indexs">
            <el-col :span="3" style="margin-left: 35px;">
              <div style="width: 3px;height:20px;background-color:#0000FE;"></div>
            </el-col>
            <el-col :span="12" >
              {{items.address}}
            </el-col>
          </el-row>
        </el-row>
      </el-col>
      <el-col :span="8" style="margin-left: 1%;margin-top: 50px;">
        <template>
          <el-table
        	:data="tableData"
          height="800"
        	border
        	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">
        	<el-table-column
        	  prop="add_time"
            width="180"
        	  label="时间"
        	   >
        	</el-table-column>
        	<el-table-column
        	  prop="content"
            width="180"
        	  label="互动"
        	   >
        	</el-table-column>
        	<el-table-column
        	  prop="type"
            width="120"
        	  label="进出"
        	   >
        	</el-table-column>
        	<el-table-column
        	  prop="type_name"
            width="120"
        	  label="位置"
        	   >
        	</el-table-column>
          <el-table-column
            prop="l_id"
            width="120"
            label="Lid"
             >
          </el-table-column>
          </el-table>
        </template>
      </el-col>
      <el-col :span="8" style="margin-left: 1%;margin-top: 50px;">
        <template>
          <el-table
        	:data="tableDatag"
          height="800"
        	border
        	style="width: 100%;margin-left: 0;height: 800px;">
        	<el-table-column
        	  prop="addtime"
        	  label="时间"
        	   >
        	</el-table-column>
        	<el-table-column
        	  prop="good_text"
        	  label="输入"
        	   >
        	</el-table-column>
        	<el-table-column

        	  label="输出"
        	   >
             <template slot-scope="scope">
               <img style="width: 120px;height: 100px;" :src="scope.row.goods_image">
               <span style="margin-left: 10px">{{scope.row.goods_name}}</span>
             </template>
        	</el-table-column>
        	<el-table-column

        	  label="结果"
        	   >
            <template slot-scope="scope">
              <div style="margin-left: 10px">名称:{{scope.row.goods_name}}</div>
              <div style="margin-left: 10px">价格:{{scope.row.goods_price}}</div>
              <div style="margin-left: 10px">时间:{{scope.row.delivery_time}}</div>
              <div style="margin-left: 10px">位置:{{scope.row.address}}</div>
            </template>
        	</el-table-column>

          </el-table>
        </template>

      </el-col>
    </el-row>




  </el-container>

</template>

<script>

  export default {
    data() {
      return {
        value2:'',
        page:1,
        phone:'',
        count:0,
        tableData:[],
        tableDatag:[],
        user:'',
        address:[],
		times:'',
		type:2,
		 url:this.$store.getters.getUrl
      };
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }

    },
	methods:{
		loadData(){
      if(this.value2 == ''){
        this.msg('选择日期!','error');
        return false;
      }
      if(this.phone == ''){
        this.msg('请输入用户手机号!','error');
        return false;
      }
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			let times = '';
			if(this.times != ''&&this.times != null){
				times = this.times[0]+','+this.times[1];
			}
			axiosInstance({
				method:'post',
				url:'http://y31p.yoooooo.com/index.php/index/data/loadTz',
				params:{
					times:this.value2,
					phone:this.phone,
          page:this.page,
				}
			})
			.then(res=>{
				this.tableData = res.data.data
        this.tableDatag = res.data.datag
        this.user = res.data.user
        this.address = res.data.address
        this.count = res.data.count;
			})
			.catch(err=>{

			});
		},

		search(){
			this.loadData()
		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},

		}


  }
</script>

<style>

  .user_n:after{
    content: '';
    position: absolute;
    left: 10%;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 80%;
    background-color: #d9dcde;
  }
	.list{
		margin-left: 15%;
		margin-right: 15%;
	}
	.h-list{
		margin: 30px 30px 30px 20px;
		background: #fff;
		height: 50px;
	}
	.h-list .el-col{
		line-height: 50px;

	}

	.s-list{
		margin-bottom: 30px;
		margin-top: 30px;

	}
	.t-searched{
		background: orange;
		color: #fff;
		height: 37px;
		line-height: 37px;
		margin-left: 30px;
		text-align: center;
	}

</style>



// WEBPACK FOOTER //
// src/components/main/tz.vue